<template>
    <div class="l-navigation">
        <div class="l-navigation-bg"></div>
        <div class="l-navigation-container">
            <img src="https://chezagame.com/images/chezagame-logo.png" width="93px" class="p-top" style="position: sticky;" />
            <ul>
                <li class="p-top"></li>
                <li :class="{'active': this.$route.name == 'dashboard'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'dashboard'}"><i class="fa fa-chart-pie fa-fw"></i><span>Dashboard</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'transaction'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'transaction'}"><i class="fa fa-arrow-down fa-fw"></i><span>Transaction</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'withdraws'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'withdraws'}"><i class="fa fa-money-check"></i><span>Withdraws</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'deposit'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'deposit'}"><i class="fa fa-money-bill fa-fw"></i><span>Deposit</span></router-link>
                </li>
                <li class="p-top" style="border-bottom: 1px dotted gray; border-top: 1px dotted gray; color: gray; padding-bottom: 5px; padding-top: 5px; font-size: x-small;">
                    USSD Games
                </li>
                <li :class="{'active': this.$route.name == 'spinWheel'}" >
                    <router-link :to="{name: 'spinWheel'}"><i class="fa fa-cog fa-fw"></i><span>Spinwheel Bets</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'aviatorBets'}">
                    <router-link :to="{name: 'aviatorBets'}"><i class="fa fa-fighter-jet fa-fw"></i><span>Aviator Bets</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'pickboxBets'}">
                    <router-link :to="{name: 'pickboxBets'}"><i class="fa fa-box-open fa-fw"></i><span>Pickbox Bets</span></router-link>
                </li>
                <li class="p-top" style="border-bottom: 1px dotted gray; border-top: 1px dotted gray; color: gray; padding-bottom: 5px; padding-top: 5px; font-size: x-small;">
                    Members
                </li>
                <li :class="{'active': this.$route.name == 'profiles'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'profiles'}"><i class="fa fa-users fa-fw"></i><span>Profiles</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'customers'}">
                    <router-link :to="{name: 'customers'}"><i class="fa fa-user fa-fw"></i><span>Customers</span></router-link>
                </li>
                <li class="p-top" style="border-bottom: 1px dotted gray; border-top: 1px dotted gray; color: gray; padding-bottom: 5px; padding-top: 5px; font-size: x-small;">
                    Settings
                </li>
                 <li :class="{'active': this.$route.name == 'kraTax' || this.$route.name == 'kraStakeTax'|| this.$route.name == 'kraOutcomeTax'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'kraTax'}"><i class="fas fa-money-check"></i><span>KRA TAx</span></router-link>
                </li>
                 <li :class="{'active': this.$route.name == 'matche' || this.$route.name == 'matcheArchived' || this.$route.name == 'sportbet' || this.$route.name =='sports' || this.$route.name =='competition' || this.$route.name =='matchePending' || this.$route.name =='category' || this.$route.name =='country' || this.$route.name =='market'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'matche'}"><i class="fas fa-futbol"></i><span>SportBook</span></router-link>
                </li>
                <li :class="{'active': this.$route.name == 'ticketPriority' || this.$route.name =='ticket' || this.$route.name == 'ticketType' || this.$route.name == 'ticketStatus' || this.$route.name == 'ticketSubType'}" v-show="stateAuditor || stateAdmin">
                    <router-link :to="{name: 'ticket'}"><i class="fa fa-ticket-alt fa-fw"></i><span>Tickets</span></router-link>
                </li>
                <li class="" :class="{'active': this.$route.name == 'admin'}" v-show="stateAdmin">
                    <router-link :to="{name: 'admin'}"><i class="fa fa-star fa-fw"></i><span>Admin</span></router-link>
                </li>
            </ul>
        </div>
        <div class="l-navigation-options">
            <button v-on:click="logout()" class="button white">Logout</button>
        </div>
    </div>
</template>

<script>
import store from "../store";
import $ from 'jquery'
export default {
    data: function() {
        return {
            stateAdmin: false,
            stateAuditor: false,
            stateCS: false
        }
    },
    mounted() {
        var vm = this;
        $(".l-navigation .l-navigation-container ul li").each(function() {
            $(this).click(function() {
                vm.$parent.showNav = false;
            });
        });
        $(".l-navigation-bg").click(function() {
            vm.$parent.showNav = false;
        });
        if (vm.$cookies.get("role_id") == 1 || vm.$cookies.get("role_id") == 2) {
            vm.stateAdmin = true;
        }
    },
    methods: {
        logout() {
            let vm = this;
            vm.$cookies.remove("accessToken");
            vm.$cookies.remove("profileInfo");
            vm.$cookies.remove("role_id");
            vm.$router.push({
                name: 'login'
            });
        },

    }
}
</script>